import { utils, writeFile } from "xlsx/xlsx.mjs";

/**
 * @param {string} title
 * @param {string[][]} data
 */
export function downloadExcel(title, data) {
    const ws = utils.aoa_to_sheet(data);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'worksheet');
    writeFile(wb, title + '.xlsx');
}
